import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions } from 'react-native';
import { SpeechScreen } from './speeches.js';
import { TopBar } from './topBar.js'
import * as RootNavigation from '../../../root.navigation.js';


const width = Dimensions.get('window').width;


const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);
export const SupportScreen = ({ navigation }) => {


  return (

    <ScrollView>
      <Layout style={styles.container} level='2' >
        <Layout>
          <TopBar title='پشتیبانی' />
          <Button
            style={{marginVertical:10,borderRadius:10,paddingVertical:10, marginHorizontal:17, zIndex:10}}
            accessoryLeft={PlusIcon}
            onPress={()=>{RootNavigation.navigate('NewRequest')}}
            >ثبت درخواست جدید</Button>
          <SpeechScreen />

        </Layout>

      </Layout>
</ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    alignItems:'center',
    justifyContent:'space-between',
    paddingBottom:5,
  },
});
